//src/utils/OneSignal.ts
import { clientConfig } from "../config";
import { getLanguageFromPath } from "../oneSignal/languageDetector";
import * as translator from "../utils/translator.js";
interface PromptStrings {
  actionMessage: string;
  acceptButtonText: string;
  cancelButtonText: string;
}
const getTranslationBylang =(lang:string) :PromptStrings=>{
  return{
  actionMessage: translator.translate(lang, "default", "oneSignalSignUpPrompt/title"),
  acceptButtonText: translator.translate(lang, "default", "oneSignalSignUpPrompt/registerButton"),
  cancelButtonText: translator.translate(lang, "default", "oneSignalSignUpPrompt/laterButton")
}
}

let initialized = false
export const init = () => {
  if (initialized){
    return
  }
  initialized = true
  

  

  // 2. Get language and the corresponding translation strings
  const currentLanguage = getLanguageFromPath();
  // Default to English translations if the current language isn't in our object
  const promptStrings = getTranslationBylang(currentLanguage) || getTranslationBylang('de');

  let windowAsAny = window as any;

  const uuid = windowAsAny.eventsTracking.getData("uuid");

  windowAsAny.OneSignalDeferred = windowAsAny.OneSignalDeferred || [];
  windowAsAny.OneSignalDeferred.push(async (OneSignal: any) => {
    try {
      await OneSignal.init({
        appId: clientConfig.ONESIGNAL_APP_ID,
        notifyButton: {//The Bell
          enable: false,
        },
        // This tells OneSignal which language to use for any of its own default text
        language: currentLanguage,
        // This sets the text for the slide-down prompt YOU control
        promptOptions: {
          slidedown: {
            enabled: true,
            //Max length is 90 characters
            //see ref :"https://github.com/OneSignal/react-onesignal/blob/main/index.ts"
            actionMessage: promptStrings.actionMessage,
            acceptButtonText: promptStrings.acceptButtonText,
            cancelButtonText: promptStrings.cancelButtonText,
          },
        },
        serviceWorkerParam: { scope: "/" },
        serviceWorkerPath: "OneSignalSDKWorker.js",
      });
      if (uuid) {
        await OneSignal.login(uuid);
      }

      const createTags = (permission: any) => {
        if (permission) {
          const tags: any = {
            currentUrl: windowAsAny.location.href,
            currentTitle: document.title,
          };
          const params = new URLSearchParams(window.location.search);
          for (const [key, value] of params.entries() as any) {
            tags[key] = value;
          }
          OneSignal.User.addTags(tags);
        }
      };
      OneSignal.Notifications.addEventListener("permissionChange", createTags);
    } catch (err:any) {
      // mute one signal not enabled for current funnel domain
      if (!err.message.includes("This web push config can only be used")){
        window.clientLogger.warn("error loading one signal", err);
      }
    }
  });

  let oneSignalScript = document.createElement("script")
  oneSignalScript.setAttribute("src","https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js")  
  document.body.append(oneSignalScript)

};
